import { Switch } from 'react-router-dom'

import Home from 'ui/screens/Home'
import Summary from 'ui/screens/Summary'
import Terms from 'ui/screens/Terms'
import Policy from 'ui/screens/Policy'
import Checkout from 'ui/screens/Checkout'
import Success from 'ui/screens/Success'

import BaseLayout from 'ui/layouts/BaseLayout'

function Routes() {
  return (
    <Switch>
      <BaseLayout path="/summary" component={Summary} />
      <BaseLayout path="/terms" component={Terms} />
      <BaseLayout path="/policy" component={Policy} />
      <BaseLayout path="/checkout" component={Checkout} />
      <BaseLayout path="/success" component={Success} />
      <BaseLayout component={Home} />
    </Switch>
  )
}

export default Routes
